<template>
  <div class="saas-integration-card">
    <div
      :class="`saas-integration-card__colored-header saas-integration-card__colored-header--${integration.color}`"
    ></div>
    <div class="saas-integration-card__icon">
      <img
        v-if="integration.icon"
        :src="integration.icon.image.src"
        :alt="integration.icon.title"
        :srcset="`${integration.icon.retina_image.src} 2x`"
      />
    </div>
    <div class="saas-integration-card__title">{{ integration.name }}</div>

    <ul class="saas-integration-card__path">
      <li class="saas-integration-card__path-item">
        {{ integration.category }}
      </li>
      <li>
        <i
          class="saas-integration-card__path-separator iconoir-nav-arrow-right"
        ></i>
      </li>
      <li class="saas-integration-card__path-item">
        {{ integration.type }}
      </li>
    </ul>

    <div class="saas-integration-card__button-container">
      <CmsLink
        :url-or-path="integration.connect_url"
        class="button button--secondary button--large button--full-width"
      >
        Connect
      </CmsLink>
    </div>
  </div>
</template>

<script>
import CmsLink from '@saas/components/cms/CmsLink'

export default {
  name: 'IntegrationCard',
  components: { CmsLink },
  props: {
    integration: {
      type: Object,
      required: true,
    },
  },
}
</script>
